import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CotizadorService } from 'src/app/services/cotizador.service';
import {
  ChangeDetectorRef,
  AfterViewInit,
  Component,
  Inject,
  HostListener
} from '@angular/core';
import {
  IInsurance,
  IInsuranceDic,
  IInsuranceSelected,
  InsurancesDic,
} from '../interfaces/aseguradoras';

import SwiperCore, { SwiperOptions, Pagination } from 'swiper';
import { environment } from 'src/environments/environment';
import { WINDOW } from 'src/app/utils/window';
import { Platform } from '@angular/cdk/platform';


SwiperCore.use([Pagination]);

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements AfterViewInit {
  templateSuffix = environment.templateSuffix;
  insurances: IInsurance[][] = [];

  insuranceFirst!: IInsuranceDic;
  insuranceBetter: IInsuranceDic = InsurancesDic[4];

  currentRadio!: IInsuranceDic;

  ready: boolean = false;

  screenSize: any = this.window.innerWidth;
  screenWidth: any = this.window.innerWidth;
  screenHeight: any = this.window.innerHeight;

  config: SwiperOptions = {
    slidesPerView: 1.5,
    spaceBetween: 50,
    centeredSlides: true,
    pagination: {
      clickable: true
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 50
      }
    }
  };

  public periods: number[] = [];

  constructor(
    private cdRef: ChangeDetectorRef,
    private cotizadorService: CotizadorService,
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(WINDOW) private window: Window,
    private platform: Platform
  ) {
    this.screenSize = this.window.innerWidth;
    this.insuranceBetter = data.insuranceBetter;
    this.currentRadio = data.insuranceSelected;
  }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();

    setTimeout(() => {
      this.ready = true;

      this.cotizadorService.insurnaces.subscribe((resp) => {

        const [ firstInsurance ] = resp;
        const periods = firstInsurance.map(({plazo}) => Number(plazo));
        this.periods = periods;
        
        const filteredData = resp.flat().filter((obj: any) => obj.plazo === '36');
        const minCostObj = filteredData.reduce((min: any, curr: any) => (curr.cost < min.cost ? curr : min), { cost: Infinity });
        resp.forEach((insuranceArray: any) => {
          insuranceArray.forEach((insurance: IInsurance) => {
            insurance.better = insurance.insurance === minCostObj.insurance;
          });
        });
        this.insurances = resp;

      });
    }, 0);
  }

  cancel() {
    this.dialogRef.close(null);
  }

  closeWithValue() {
    let filtro: IInsurance[] = [];

    for (const insurance of this.insurances) {
      if (insurance[0].insurance === this.currentRadio.key) {
        filtro = insurance;
        break;
      }
    }

    let insuranceSelected: IInsuranceSelected = {
      data: filtro,
      insurance: this.currentRadio,
    };

    this.dialogRef.close(insuranceSelected);
  }

  getClassCol() {
    let factor = 12 / this.insurances.length;
    return `col-${factor}`;
  }

  isCheck(insuranceCurrent: string): boolean {
    return this.currentRadio.key === insuranceCurrent || false;

  }

  onChange(insurance: string) {
    this.currentRadio = InsurancesDic.find((ele) => ele.key === insurance)!;
  }

  resultCompare(insuranceBetter: boolean): string {
    return insuranceBetter ? 'better' : '';
  }

  @HostListener('window:resize')
  onResize() {
    this.screenSize = this.window.innerWidth;
  }

  isMobile() {
    return this.screenWidth < 768 || this.platform.ANDROID || this.platform.IOS;
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(): void {
    this.screenWidth = this.window.innerWidth;
    this.screenHeight = this.window.innerHeight;
    this.isMobile();
  }


}
